<div class="grid align-center padding-horizontal-medium padding-bottom-medium document-template">
  <div class="cell cell-large-col-span-12">
    <h1 class="margin-bottom-medium">Important Documents</h1>
    <p class="cell cell-large-col-span-12 margin-bottom-medium">This page lists all the important documents related to your policy, including our terms and conditions and privacy policy. Click below to find the document applicable to your purchase date.</p>
  </div>
  
  <div *ngFor="let product of documentListing | keyvalue" class="cell cell-large-col-span-4 flex flex-column">
    <mat-icon [ngClass]="{'directions_car': product.value.type === 'car', 'flight': product.value.type === 'travel', 'home': product.value.type === 'home'}" class="service-icon margin-bottom-medium" width="40"></mat-icon>
    <h3 class="margin-bottom-medium">{{ partnerBrandService.data.partner.name }} <span class="text-capitalize">{{ product.value.type }}</span> Insurance</h3>
    <p class="margin-bottom-medium">Applies to policies quoted on or after {{ product.value.pdsLatestDocumentDate }}</p>
    
    <div *ngIf="product.value.pdsDocuments.length !== 0" class="margin-bottom-medium">
      <h3 class="margin-bottom-medium">{{ product.value.label }}</h3>
      <div *ngFor="let document of product.value.pdsDocuments" class="margin-bottom-xxsmall">
        <a *ngIf="document.type === 'pds'" [href]="apiEndpoint + document?.url" color="primary">
          <mat-icon class="file_download material-icons-outlined margin-right-xsmall download-icon"></mat-icon>{{ document?.name }}
        </a>
      </div>
    </div>
    
    <div *ngIf="product.value.resourceDocuments.length !== 0">
      <h3 class="margin-bottom-medium">Resources</h3>
      <div *ngFor="let document of product.value.resourceDocuments" class="margin-bottom-xxsmall">
        <a *ngIf="document.type !== 'pds'" [href]="apiEndpoint + document?.url" color="primary">
          <mat-icon class="file_download material-icons-outlined margin-right-xsmall download-icon"></mat-icon>{{ document?.name }}
        </a>
      </div>
    </div>
  </div>
</div>


<ng-template #noData>
  <!-- Spinner if userData is being fetched -->
  <p>No data...</p>
</ng-template>
